import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Alert } from "react-bootstrap";

export default function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <Container className="legal-page">
      <div className="legal-header">
        <h2 className="legal-title">
          Mentions légales & Politique de confidentialité
        </h2>

        <Button
          variant="outline-secondary"
          className="legal-back-btn"
          onClick={() => navigate("/")}
          type="button"
        >
          Retour
        </Button>
      </div>

      {/* ====================== MENTIONS LEGALES ====================== */}
      <section className="legal-section">
        <h5>1. Éditeur du site</h5>
        <p>
          <strong>Nom commercial :</strong> iac design digital <br />
          <strong>Raison sociale :</strong> *iac design digital <br />
          <strong>Forme juridique :</strong> SAS <br />
          <strong>SIRET :</strong> *********** <br />
          <strong>Adresse du siège :</strong> chemin du tennis 06440 l'Escarène
          <br />
          <strong>Email :</strong> sebastien.robello@hotmail.fr <br />
          <strong>Téléphone :</strong> 0635499165 <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>2. Directeur de la publication</h5>
        <p>
          <strong>Nom / Prénom :</strong> Robello Sebastien <br />
          <strong>Contact :</strong> sebastien.robello@hotmail.fr
        </p>
      </section>

      <section className="legal-section">
        <h5>3. Hébergement</h5>
        <p>
          <strong>Hébergeur :</strong> iac design digital <br />
          <strong>Adresse :</strong> 06440 l'Escarène <br />
          <strong>Site web :</strong> iacdesigndigital.fr <br />
          <strong>Téléphone :</strong> 0635499165
        </p>
      </section>

      <section className="legal-section">
        <h5>4. Propriété intellectuelle</h5>
        <p>
          L’ensemble du contenu du site (textes, images, logos, éléments
          graphiques, code, architecture) est protégé par le droit de la
          propriété intellectuelle. Toute reproduction, représentation,
          adaptation ou exploitation, totale ou partielle, sans autorisation
          préalable, est interdite.
        </p>
      </section>

      <section className="legal-section">
        <h5>5. Responsabilité</h5>
        <p>
          Les informations affichées sur le site sont fournies à titre
          indicatif. L’éditeur met en œuvre des moyens raisonnables pour assurer
          l’exactitude des contenus, mais ne peut garantir l’absence d’erreurs.
          L’éditeur ne saurait être tenu responsable des dommages directs ou
          indirects liés à l’utilisation du site.
        </p>
      </section>

      <section className="legal-section">
        <h5>6. Liens externes</h5>
        <p>
          Le site peut contenir des liens vers des sites tiers. L’éditeur
          n’exerce aucun contrôle sur ces sites et décline toute responsabilité
          quant à leur contenu, leurs pratiques ou leur disponibilité.
        </p>
      </section>

      {/* ====================== RGPD / CONFIDENTIALITE ====================== */}
      <div className="legal-divider" />

      <section className="legal-section">
        <h5>7. Politique de confidentialité (RGPD) – Introduction</h5>
        <p>
          La présente politique explique comment vos données personnelles sont
          collectées, utilisées et protégées lorsque vous utilisez ce site et
          ses services (contact, réservation, consultation).
        </p>
      </section>

      <section className="legal-section">
        <h5>8. Responsable du traitement</h5>
        <p>
          <strong>Responsable :</strong> Robello sébastien <br />
          <strong>
            Email de contact RGPD :
          </strong> sebastien.robello@hotmail.fr <br />
          <strong>Adresse :</strong> chemin du tennis 06440 l'Escarène
        </p>
      </section>

      <section className="legal-section">
        <h5>9. Données collectées</h5>
        <p>
          Selon votre utilisation, nous pouvons collecter :
          <br />
          <strong>— Identité & contact :</strong> nom, prénom, email, téléphone{" "}
          <br />
          <strong>— Réservation :</strong> adresses départ/arrivée, date/heure,
          options, demandes spécifiques, informations nécessaires au traitement{" "}
          <br />
          <strong>— Données techniques :</strong> informations de navigation
          (logs, IP, navigateur, pages consultées), uniquement si nécessaire à
          la sécurité / mesure d’audience <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>10. Finalités du traitement</h5>
        <p>
          Vos données sont utilisées pour :
          <br />
          <strong>—</strong> traiter et confirmer les demandes de réservation{" "}
          <br />
          <strong>—</strong> assurer la relation client (informations,
          modifications, suivi) <br />
          <strong>—</strong> répondre aux messages via le formulaire de contact{" "}
          <br />
          <strong>—</strong> assurer la sécurité du service et prévenir la
          fraude <br />
          <strong>—</strong> respecter les obligations légales et comptables, le
          cas échéant <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>11. Bases légales (RGPD)</h5>
        <p>
          Les traitements sont fondés sur :
          <br />
          <strong>
            — Exécution d’un contrat / mesures précontractuelles :
          </strong>{" "}
          traitement des réservations <br />
          <strong>— Consentement :</strong> lorsque requis (ex: certains
          cookies, communications marketing si mises en place) <br />
          <strong>— Intérêt légitime :</strong> sécurité, amélioration du
          service, prévention des abus <br />
          <strong>— Obligation légale :</strong> si applicable (comptabilité,
          obligations réglementaires) <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>12. Durées de conservation</h5>
        <p>
          Les durées peuvent varier selon la finalité :
          <br />
          <strong>— Données de réservation :</strong> trois années <br />
          <strong>— Données de contact :</strong> trois années <br />
          <strong>— Logs / sécurité :</strong> trois années <br />
          Les données sont supprimées ou anonymisées à l’issue des durées de
          conservation, sauf obligation légale contraire.
        </p>
      </section>

      <section className="legal-section">
        <h5>13. Destinataires des données</h5>
        <p>
          Les données sont destinées aux personnes habilitées chez l’éditeur.
          Elles peuvent être transmises à des prestataires techniques
          indispensables au fonctionnement (hébergement, envoi d’emails,
          maintenance), dans le respect du RGPD, avec des garanties appropriées.
        </p>
      </section>

      <section className="legal-section">
        <h5>14. Transferts hors UE</h5>
        <p>
          Les données ne sont jamais traitées hors de l’Union Européenne.
          <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>15. Sécurité</h5>
        <p>
          Des mesures techniques et organisationnelles raisonnables sont mises
          en œuvre afin de protéger vos données contre l’accès non autorisé, la
          perte, l’altération ou la divulgation (contrôles d’accès, chiffrement
          si applicable, journalisation, sauvegardes).
        </p>
      </section>

      <section className="legal-section">
        <h5>16. Vos droits</h5>
        <p>
          Conformément au RGPD, vous disposez des droits suivants :
          <br />
          <strong>—</strong> accès, rectification, effacement <br />
          <strong>—</strong> limitation, opposition <br />
          <strong>—</strong> portabilité (selon conditions) <br />
          <strong>—</strong> retrait du consentement (si applicable) <br />
          Pour exercer vos droits, contactez :{" "}
          <strong>iacdesigndigital.fr</strong>.
        </p>
      </section>

      <section className="legal-section">
        <h5>17. Réclamation</h5>
        <p>
          Si vous estimez que vos droits ne sont pas respectés, vous pouvez
          déposer une réclamation auprès de l’autorité de contrôle compétente
          (en France : CNIL).
        </p>
      </section>

      <section className="legal-section">
        <h5>18. Cookies</h5>
        <p>
          Le site peut utiliser des cookies et traceurs :
          <br />
          <strong>— Cookies nécessaires :</strong> fonctionnement du site (non
          soumis au consentement) <br />
        </p>
      </section>

      <section className="legal-section">
        <h5>19. Mise à jour</h5>
        <p>
          Cette page peut être mise à jour à tout moment. Dernière mise à jour :{" "}
          <strong>20/01/2026</strong>.
        </p>
      </section>
    </Container>
  );
}
